import request from '@/utils/request'

export const userApi = {
  list: params => request.get('/system/user/list', { params }),
  create: data => request.post('/system/user', data),
  update: data => request.put('/system/user', data),
  remove: userId => request.delete(`/system/user/${userId}`),
  batchRemove: data => request.delete('/system/user/batch', { data }),
  roleIds: userId => request.get(`/system/user/${userId}/roles`),
  updateRoles: (userId, roleIds) => request.put(`/system/user/${userId}/roles`, { roleIds })
}

export const roleApi = {
  list: params => request.get('/system/role/list', { params }),
  create: data => request.post('/system/role', data),
  update: data => request.put('/system/role', data),
  remove: roleId => request.delete(`/system/role/${roleId}`),
  batchRemove: data => request.delete('/system/role/batch', { data }),
  menuIds: roleId => request.get(`/system/role/${roleId}/menus`),
  updateMenus: (roleId, menuIds) => request.put(`/system/role/${roleId}/menus`, { menuIds })
}

export const menuApi = {
  tree: () => request.get('/system/menu/tree'),
  list: params => request.get('/system/menu/list', { params }),
  create: data => request.post('/system/menu', data),
  update: data => request.put('/system/menu', data),
  remove: menuId => request.delete(`/system/menu/${menuId}`),
  batchRemove: data => request.delete('/system/menu/batch', { data })
}
